import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TooltipModule } from '@soti/tooltip';

import { PipesModule, XsI18nPipe } from '@nx-fe/pipes';

import { SharedComponentsModule } from 'app/shared/shared-components.module';

import { SnapshotComponent } from './snapshot/snapshot.component';
import { DeviceInfoViewModule } from './snapshot/device-info-view/device-info-view.module';
import { SnapshotTitleBarComponent } from './snapshot/snapshot-title-bar/snapshot-title-bar.component';
import { SnapshotButtonsComponent } from './snapshot/snapshot-buttons/snapshot-buttons.component';
import { DeviceInfoModule } from './snapshot/device-info/device-info.module';

@NgModule({
  imports: [
    CommonModule,
    DeviceInfoViewModule,
    TooltipModule,
    MatProgressSpinnerModule,
    PipesModule,
    SharedComponentsModule,
    FormsModule,
    DeviceInfoModule
    //
  ],
  declarations: [SnapshotComponent, SnapshotTitleBarComponent, SnapshotButtonsComponent],
  exports: [SnapshotComponent, SnapshotButtonsComponent],
  providers: [DatePipe, XsI18nPipe],
})
export class SnapshotModule {}
